'use strict';

// check if a module deserve to stay visible,
// If not -> delete it + delete his link in the left menu

function checkEmptyModuleSection () {
  var $reportContent = $('#report-content');
  var $leftNav = $('#left-nav');
  var $moduleNavLink;

  $reportContent.find('.module.module-empty').addClass('hidden');

  $reportContent.find('.module:not(.hidden)').each(function () {
    var $module = $(this);
    var $moduleToCheck = $module
      .find('.criterium:not(.hidden), .review-cta');

    if ($moduleToCheck.length === 0) {
      $module.addClass('hidden');

      // Hide module in nav
      $moduleNavLink = $leftNav.find('a[href=#' + $module.attr('id') + ']');
      $moduleNavLink.addClass('hidden');
    }
  });

  // Hide section where all modules are hidden
  $leftNav.find('.nav-section').each(function () {
    var $sectionNav = $(this);
    var $sectionLink = $sectionNav.find('a.section-title');
    var $sectionsToCheck = $sectionNav
      .find('.inpage-link:not(.section-title, .hidden)');

    if ($sectionLink.hasClass('inpage-link') &&
      $sectionsToCheck.length === 0) {
      var sectionSelector = $sectionLink.attr('href');

      $(sectionSelector).addClass('hidden');
      $sectionNav.addClass('hidden');
    }
  });
}

module.exports = checkEmptyModuleSection;
